<script>
// Allows stubbing BaseLink in unit tests

export default {
  // Functional components are stateless, meaning they can't
  // have data, computed properties, etc and they have no
  // `this` context.
  functional: true,
  props: {
    routes: {
      type: Array,
      required: true,
    },
  },
  // Render functions are an alternative to templates
  render(h, { props, $style = {} }) {
    function getRouteTitle(route) {
      return typeof route.title === 'function' ? route.title() : route.title
    }
    function getActive(route) {
      if (window.location.href.includes(route.name)) {
        return 'nav--menu_item active'
      } else {
        return 'nav--menu_item'
      }
    }

    // Functional components are the only components allowed
    // to return an array of children, rather than a single
    // root node.
    return props.routes.map((route) => (
      <a-menu-item
        key={route.name}
        active={$style.active}
        class={getActive(route)}
      >
        <router-link to={route}>
          <a-icon type={route.iconType} />
          <span className='nav-text'>{getRouteTitle(route)}</span>
        </router-link>
      </a-menu-item>
    ))
  },
}
</script>

<style lang="scss">
@import '@design';

li.ant-menu-item.nav--menu_item.active {
  background: #1890ff;
  a {
    font-weight: 600;
    color: white;
    text-decoration: none;
    cursor: default;
  }
}
</style>
